import { CountryWrapper } from "model/support-types";
import { IQuestionDetailDTO } from "api/swagger/ApiClient";

export interface QuestionDetailModel {
  data: IQuestionDetailDTO;
  isVisible: boolean;
  isQuestionEditing: boolean;
  countriesWrapper: CountryWrapper[];
  isGlobal: boolean;
  questionDataChanged(item: QuestionDetailModel): void;
}
